

export enum CollectionsActionTypes {
  FETCH_COLLECTIONS = 'FETCH_COLLECTIONS',
}
